import { render, staticRenderFns } from "./dui-editor-toolbar.vue?vue&type=template&id=243a1bd5&scoped=true&"
import script from "./dui-editor-toolbar.vue?vue&type=script&lang=js&"
export * from "./dui-editor-toolbar.vue?vue&type=script&lang=js&"
import style0 from "./dui-editor-toolbar.vue?vue&type=style&index=0&id=243a1bd5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243a1bd5",
  null
  
)

export default component.exports